import React from 'react'
import '../css/mainpage.css'
import Navbar from './Navbar.js'

const Mainpage = () => {
  return (
    <React.Fragment>
        <section className='head'>
        <Navbar/>
        </section>
    </React.Fragment>
  )
}

export default Mainpage